export const NOMINAL_ACCOUNT_REQUESTS_DELAY = 1000;
